// AUTO-GENERATED at build time by scripts/gen-card-index.js — do not edit by hand.
// Card/section/tab titles across the app, mapped to their page route (roles inherit the destination).
const ALL = ['admin', 'regional_manager', 'branch_manager', 'loan_officer', 'cashier'];

export const CARD_INDEX = [
  { label: 'Continue with Google', href: '/staff/login', roles: ALL, keywords: 'button action' },
  { label: 'Staff Portal', href: '/staff/login', roles: ALL, keywords: 'card' },
  { label: 'Register', href: '/staff/register?tab=register', roles: ALL, keywords: 'tab' },
  { label: 'Check Status', href: '/staff/register?tab=status', roles: ALL, keywords: 'tab' },
  { label: 'Staff Registration', href: '/staff/register', roles: ALL, keywords: 'card' },
];
